<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Number -->
    <block-number-field
      v-model="$attrs.block.number"
      :error="$attrs.errors.block.number"
    />

    <!-- Building -->
    <building-field
      v-model="$attrs.block.building"
      :error="$attrs.errors.block.building"
      v-show="!(formType == 'add' && $attrs.block.building)"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import blockNumberField from '@/components/forms/block/fields/BlockNumber'
import buildingField from '@/components/forms/block/fields/Building'

export default {
  name: 'block-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    },
    formType: {
      type: String,
      required: true
    }
  },
  components: {
    blockNumberField,
    buildingField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// BlockBlankForm.vue?0a65f663